import { useForm } from 'react-hook-form';
import {
  Button,
  CardHeader,
  Dropdown,
  Text,
  InputText,
  InputDate,
  SectionHeader,
  TextArea,
} from '@pentabd/ui';
import { IconCalendar } from '@pentabd/icons';

import Comments from './Comments';
import SupportingDocuments from './SupportingDocuments';

const NotificationDetails = ({ selected }: any) => {
  const { handleSubmit } = useForm<FormData>();
  const onSubmit = (data: any) => {
    console.log(data);
  };
  const data1 =
    '<h1>Heading 1</h1><h2>Heading 2</h2><h3>Heading 3</h3><h1>Heading 1</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis nisl cursus bibendum sit nulla accumsan sodales ornare. At urna viverra non suspendisse neque, lorem. Pretium condimentum pellentesque gravida id etiam sit sed arcu euismod. Rhoncus proin orci duis scelerisque molestie cursus tincidunt aliquam.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis nisl cursus bibendum sit nulla accumsan sodales ornare. At urna viverra non suspendisse neque, lorem. Pretium condimentum pellentesque gravida id etiam sit sed arcu euismod. Rhoncus proin orci duis scelerisque molestie cursus tincidunt aliquam.</p><ul><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li></ul>';

  return (
    <div>
      <div className="px-9 border-bottom">
        <CardHeader
          title={selected.title}
          description="কমিশনার (তদন্ত)"
          avatar={{
            size: 'sm',
            imageURL: 'https://i.pravatar.cc/300',
          }}
          buttons={[
            <Button key={1} fill="outline" type="primary">
              Send Back
            </Button>,
            <Button key={2} htmlType="submit" fill="fill" type="danger">
              Reject
            </Button>,
            <Button key={2} htmlType="submit" fill="fill" type="primary">
              Approve
            </Button>,
            <div className="d-flex justify-content-center align-items-center">
              <Dropdown buttonType="icon"></Dropdown>
            </div>,
          ]}
        />
      </div>
      <div className="px-9">
        <form className="container py-9" onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex flex-column gap-9">
            <div className="row">
              <div className="col-3">
                <Text weight="semibold" size="sm" color="title">
                  Current Posting
                </Text>
              </div>
              <div className="col-9">
                <InputText
                  name="current_posting"
                  placeholder="Dhaka"
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="col-3">
                <Text weight="semibold" size="sm" color="title">
                  Transferred Posting
                </Text>
              </div>
              <div className="col-9">
                <InputText
                  name="transferred_posting"
                  placeholder="Bagura"
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="col-3">
                <Text weight="semibold" size="sm" color="title">
                  Takeover Date
                </Text>
              </div>
              <div className="col-9">
                <InputDate
                  name="takeover_date"
                  disabled
                  prefix={
                    <IconCalendar size="24" stroke="subtitle2" fill="none" />
                  }
                />
              </div>
            </div>
          </div>
        </form>
        <div className="border px-7 py-6">
          <div dangerouslySetInnerHTML={{ __html: data1 }} />
        </div>
        <hr className="hr-color my-9" />
        <div className="mb-9">
          <SectionHeader title="Supporting Documents" />
        </div>
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <SupportingDocuments />
        </form>
        <div>
          <Comments />
        </div>
        <TextArea name="comments" placeholder="Send a message" />
        <div className="row d-flex flex-row-reverse py-8 px-4">
          <Button key={3} htmlType="submit" type="info">
            Send
          </Button>
        </div>
      </div>
    </div>
  );
};
export default NotificationDetails;
